module.exports = "https://cdn.hellotech.com/client-assets/tech-client-speaker-mobile_6098be46837a9b13f8f2227ef496da14.webp";